var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"campaign-table-wrap bg-white dark:bg-slate-900 flex-1 h-full overflow-hidden"},[_c('ve-table',{attrs:{"fixed-header":true,"max-height":"calc(100vh - 7.125rem)","columns":_vm.columns,"table-data":_vm.tableData.slice(
        (_vm.meta.currentPage - 1) * _vm.meta.perPage,
        (_vm.meta.currentPage - 1) * _vm.meta.perPage + _vm.meta.perPage
      ),"border-around":false,"sort-option":_vm.sortOption}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }